.container {
  min-height: 100vh;
}

.item {
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  text-align: left;
  border: none;
  cursor: pointer;
  color: inherit;
}

.unread {
  background: rgba(255, 255, 255, 0.1);
  border-left: 3px solid #f59e0b;
}

.loadMore {
  width: 100%;
}
